import RouteConfig from './config/RouteConfig';
import QuickQuoteAddress from './directives/Address/PaQuickQuoteAddress';
import QuickQuoteVehicle from './directives/Vehicle/PaQuickQuoteVehicle';
import QuickQuoteDriver from './directives/Driver/PaQuickQuoteDriver';
import QuickQuoteEstimate from './directives/Estimate/PaQuickQuoteEstimate';
import QuickQuoteAddressInputState from './directives/Address/PaQuickQuoteAddressInputState';
import VinUpload from './directives/VinUpload/VinUpload';
import QuickQuoteLocationMap from './directives/LocationMap';
import 'angularRouter';
import 'edge/platform/map/module';
import 'edge/quoteandbind/util/app';

export default angular.module('edge.quoteandbind.quickquote.pa.app', ['edge.platform.map', 'edge.quoteandbind.util.app']).directive('gwQuickQuoteAddressPanel', QuickQuoteAddress).directive('gwQuickQuoteVehiclePanel', QuickQuoteVehicle).directive('gwQuickQuoteDriverPanel', QuickQuoteDriver).directive('gwQuickQuoteEstimatePanel', QuickQuoteEstimate).directive('gwQuickQuoteAddressInputState', QuickQuoteAddressInputState).directive('gwQuickQuoteVinUpload', VinUpload).component('gwQuickQuoteLocationMap', QuickQuoteLocationMap).constant('addressSettings', {
    minimumCharactersBeforeSearching: 3,
    msOfInactivityBeforeSearching: 500
}).config(['$stateProvider', 'state_plugin_config', function ($stateProvider, RootStateConfig) {
    var states = new RouteConfig(RootStateConfig);
    for (var stateName in states) {
        if (states.hasOwnProperty(stateName)) {
            $stateProvider.state(stateName, states[stateName]);
        }
    }
}]);


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/conditional?if=quoteandbind_lob&equals=pa!./common/js/src/edge/quoteandbind/quickquote/pa/app.js
// module id = 483
// module chunks = 0